export default "__VITE_ASSET__5hnwJ5EC__"